<template>
  <!-- Classe, e não estilo inline, porque o layout de tela cheia do admin
       (`.admin-screen`, em `assets/css/tables.css`) precisa alcançar este
       contêiner para transformá-lo em coluna flex — estilo inline venceria. -->
  <div class="base-table-scroll" @contextmenu="onContextMenu">
    <vue-good-table
      :mode="remote?'remote':'default'"
      @row-mouseenter="onRowMouseenter"
      @row-mouseleave="onRowMouseleave"
      :columns="finalColumns"
      :rows="rows"
      :search-options="mergedSearchOptions"
      :pagination-options="mergedPaginationOptions"
      :line-numbers="showIndex"
      :is-loading="isLoading"
      :total-rows="totalRows"
      @row-click="onRowSelected"
      @page-change="onPageChange"
      @sort-change="onSortChange"
      @column-filter="onColumnFilter"
      @per-page-change="onPerPageChange"
      :isLoading="isLoading"
      @change:isLoading="(e) => $emit('change:isLoading', e)"
    >
        <template #loadingContent>
            <slot name="loadingContent">
                <div class="text-center p-3 custom-loading-style">
                </div>
            </slot>
        </template>
        
        <!-- Estado vazio. A vue-good-table usa ESTE slot também enquanto carrega
             (o `#loadingContent` só vale no modo remoto), então é aqui que a
             distinção "buscando" × "não há nada" precisa acontecer. O ramo de
             carregamento lia `loading`, que nunca foi declarado como prop: era
             sempre `undefined`, e por isso toda tabela do admin anunciava
             "Nenhum registro encontrado" enquanto a requisição ainda estava no
             ar. Passa a ler `isLoading`, que é a prop que os pais já enviam. -->
        <template #emptystate>
            <slot name="emptystate" :isLoading="isLoading">
              <div class="adm-state" role="status" aria-live="polite">

                <template v-if="isLoading">
                    <span class="adm-state__icon adm-state__icon--primary">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </span>
                    <span class="adm-state__text">{{ messageLoading }}</span>
                </template>

                <template v-else>
                    <span class="adm-state__icon"><i class="ri-inbox-2-line" aria-hidden="true"></i></span>
                    <span class="adm-state__text">{{ emptyMessage }}</span>
                </template>

              </div>
            </slot>
        </template>
  
        <template #table-column="props">
          <slot name="table-column" v-bind="props">{{ props.column.label }}</slot>
        </template>

        <template #table-row="props">
          <slot name="table-row" v-bind="props" />
        </template>

    </vue-good-table>
  </div>
  </template>
  
  <script>
  export default {
    name: 'BaseTable',
    emits: ['change:isLoading', 'row-contextmenu'],
    data() {
      return {
        // A vue-good-table não emite evento de botão direito, e a `<tr>` não
        // carrega nada que a ligue de volta à linha de dados. Guardar a linha
        // sob o cursor (que ela emite) é o caminho mais curto e não depende de
        // ordem/paginação para casar DOM com dado.
        linhaSobCursor: null,
      };
    },
    props: {
      totalRows: {
        type: [Number, undefined],
        default: undefined
      },
      remote: {
        type: Boolean,
        default: false
      },
      columns: {
        type: Array,
        required: true,
      },
      rows: {
        type: Array,
        required: true,
      },
      searchOptions: Object,
      paginationOptions: Object,
      showIndex: {
        type: Boolean,
        default: false,
      },
      showActions: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      onRowSelected: {
        type: Function,
        default: (e) => console.log(e)
      },
      onPageChange   : { type: Function, default: (e) => console.log(e) },
      onSortChange   : { type: Function, default: (e) => console.log(e) },
      onColumnFilter : { type: Function, default: (e) => console.log(e) },
      onPerPageChange: { type: Function, default: (e) => console.log(e) },
      messageLoading: {
        type: String,
        default: "Carregando informações ..."
      },
      /** Texto do estado vazio de verdade — quando NÃO está carregando. */
      emptyMessage: {
        type: String,
        default: "Nenhum registro encontrado."
      },
    },
    methods: {
      onRowMouseenter({ row }) {
        this.linhaSobCursor = row;
      },
      onRowMouseleave({ row }) {
        // Só limpa se ainda for a mesma linha: ao passar de uma linha para a
        // vizinha o `mouseenter` da nova pode chegar antes deste `mouseleave`.
        if (this.linhaSobCursor === row) this.linhaSobCursor = null;
      },
      onContextMenu(event) {
        // Fora das linhas de dados (cabeçalho, busca, paginação) o menu do
        // navegador continua valendo.
        if (!this.linhaSobCursor || !event.target?.closest?.('tbody tr')) return;
        this.$emit('row-contextmenu', { row: this.linhaSobCursor, event });
      },
    },
    computed: {
      mergedSearchOptions() {
        return {
          enabled: true,
          placeholder: 'Buscar ...',
          ...this.searchOptions,
        };
      },
      mergedPaginationOptions() {
        return {
          enabled: true,
          perPage: 100,
          perPageDropdown: [5, 10, 50, 100],
          dropdownAllowAll: false,
          mode: 'pages',
          nextLabel: 'Próximo',
          prevLabel: 'Anterior',
          rowsPerPageLabel: 'Linhas por página',
          ofLabel: 'de',
          pageLabel: 'Página',
          ...this.paginationOptions,
        };
      },
      finalColumns() {
        const base = [...this.columns];
        if (this.showActions) {
          base.push({
            label: 'Ações',
            field: '__actions',
          });
        }
        return base;
      },
    },
  };
  </script>
  